import { render, staticRenderFns } from "./schnauzer.vue?vue&type=template&id=1182f12a&scoped=true"
var script = {}
import style0 from "./schnauzer.vue?vue&type=style&index=0&id=1182f12a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1182f12a",
  null
  
)

export default component.exports